import { render } from "./NotificationResultsDetails.vue?vue&type=template&id=0c4bf6a1&ts=true"
import script from "./NotificationResultsDetails.vue?vue&type=script&lang=ts"
export * from "./NotificationResultsDetails.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__